import 'date-fns';
import React from 'react';
import { FormControl, InputAdornment, TextField } from '@mui/material';
import { Lock } from '@mui/icons-material';
import { FormFieldFooter } from '../Error';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';

export const DatePickerField = ({
  input,
  label,
  meta: { touched, error },
  fullWidth,
  className,
  disabled,
  description,
  InputProps,
  minDate,
}: any) => {
  let inputProps = InputProps;
  if (disabled && !InputProps) {
    inputProps = {
      endAdornment: (
        <InputAdornment position="end">
          <Lock />
        </InputAdornment>
      ),
    };
  }
  return (
    <FormControl fullWidth={fullWidth} className={className}>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <DatePicker
          label={label}
          value={input.value || null}
          onChange={date => input.onChange(date)}
          minDate={minDate}
          disabled={disabled}
          renderInput={params => {
            const { key, ...restOfParams } = params;
            // Work around because key types do not match up (DatePicker allows for bigint, TextField allows React.Key)
            return (
              <TextField
                key={`${key}`}
                {...restOfParams}
                InputProps={inputProps}
              />
            );
          }}
        />
      </LocalizationProvider>
      <FormFieldFooter
        touched={touched}
        error={error}
        description={description}
      />
    </FormControl>
  );
};
